module.exports = __webpack_public_path__ + "img/108.3cee5e63.jpg";